import { HTMLAttributes } from "react";

export interface ModalTitleProps extends HTMLAttributes<HTMLElement> {
  title: string;
}

const ModalTitle = ({ title, className, ...props }: ModalTitleProps) => {
  return (
    <h3
      className={`textcolor text-xl font-bold ${className}`}
      {...props}>
      {title}
    </h3>
  );
};

export default ModalTitle;
